angular.module('mercury.modules.error.service')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('FullWidth.ErrorService', {
    templateUrl: 'modules/error/service/service.tpl.html'
  });
}]);
